// FixLocalTesting v1.0
// Rewrites localhost URLs to the current LAN hostname during local network testing.

export const fixLocalTesting = () => {
  const hostname = window.location.hostname;
  if (hostname.indexOf('192.168') === -1) return;

  // replace in links
  const anchors = document.querySelectorAll('a');
  anchors.forEach(element => {
    const href = element.getAttribute('href');
    if (!href) return;
    element.setAttribute('href', href.replace('localhost', hostname));
  });

  // replace in forms
  const forms = document.querySelectorAll('form');
  forms.forEach(element => {
    const action = element.getAttribute('action');
    if (!action) return;
    element.setAttribute('action', action.replace('localhost', hostname));
  });

  // replace in image lazy attributes
  const imageEls = document.querySelectorAll('img');
  imageEls.forEach(imageEl => {
    const src = imageEl.getAttribute('data-src');
    if (src) imageEl.setAttribute('data-src', src.split('localhost').join(hostname));

    const srcset = imageEl.getAttribute('data-srcset');
    if (srcset) imageEl.setAttribute('data-srcset', srcset.split('localhost').join(hostname));
  });

  if (typeof $baseUrl !== 'undefined') $baseUrl = $baseUrl.replace('localhost', hostname);
  if (typeof $url !== 'undefined') $url = $url.replace('localhost', hostname);
  if (typeof $assets !== 'undefined') $assets = $assets.replace('localhost', hostname);
};
